<template>
  <div class="container">
    <div
      :id="editorId"
      ref="editorContainer"
      class="monaco-wrapper text-left"
      :class="{ 'bg-black': theme }"
    />
  </div>
</template>

<script>
import loader from '@monaco-editor/loader'

export default {
  name: 'HealthcheckLogResponseEditor',
  props: {
    value: {
      type: [String, Object],
      default: null,
      required: true,
    },
    editorId: {
      type: String,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      contentType: this.language,
      themeLight: this.theme,
      editor: null,
      options: [
        { language: 'json', value: 'JSON' },
        { language: 'html', value: 'HTML' },
      ],
    }
  },
  computed: {
    theme() {
      return this.$store.state.app.editorLightTheme
    },
    language() {
      if (typeof this.value === 'object') {
        return 'json'
      }
      if (this.value.startsWith('<')) {
        return 'html'
      }
      return 'json'
    },
  },
  watch: {
    theme() {
      this.changeTheme()
    },
  },
  mounted() {
    const wrapper = document.getElementById(this.editorId)
    loader.init().then(monaco => {
      this.editor = monaco.editor.create(wrapper, {
        value: this.value,
        theme: this.theme,
        automaticLayout: true,
        readOnly: false,
        unusualLineTerminators: 'auto',
        wordWrap: 'on',
        wrappingIndent: 'indent',
        language: this.language,
      })
      setTimeout(() => {
        this.editor
          .getAction('editor.action.formatDocument')
          .run()
          .then(() => this.editor.updateOptions({ readOnly: true }))
      }, 100)
    })

    this.contentType = this.language
  },
  methods: {
    checkLanguage(value) {
      if (typeof this.value === 'object' || value.startsWith('{')) {
        this.value = JSON.stringify(this.value)
        this.setLanguage('json')
      }
      if (value.startsWith('<')) {
        this.setLanguage('html')
      }
    },
    setLanguage(updatedLanguage) {
      loader.init().then(monaco => {
        monaco.editor.setModelLanguage(this.editor.getModel(), updatedLanguage)
        this.editor.getAction('editor.action.formatDocument').run()
      })
    },
    changeTheme() {
      loader.init().then(monaco => {
        monaco.editor.setTheme(this.theme)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.monaco-wrapper {
  min-height: 400px;
  border-radius: 4px;
  box-shadow: 0px 0px 16px #e0e5eb;
  padding: 2px;
  background-color: none;

  .monaco-editor {
    width: auto !important;
  }
}
.custom-control-dark::v-deep {
  .custom-control-label {
    padding-left: 3rem;
    .switch-icon-right {
      right: 6px;
    }
  }
}
</style>
